"use client";

import { PracticeStructureSidebar } from "@/components/ui/organisms/chord-practice";
import { SongHeader } from "@/components/studio/song-header";

import { useChordsContext } from "./chords-context";

interface ChordsSidebarProps {
  songTitle: string | null;
  songComposer: string | null;
  onCloseSong: () => void;
}

/**
 * Sidebar du mode Chords : header morceau (si chargé) + structure
 * diatonique. Consomme le `ChordsProvider` pour la progression et la
 * sélection.
 */
export function ChordsSidebar({
  songTitle,
  songComposer,
  onCloseSong,
}: ChordsSidebarProps) {
  const { currentEntry, progress, selectEntry } = useChordsContext();

  return (
    <>
      <SongHeader
        title={songTitle}
        composer={songComposer}
        onClose={onCloseSong}
      />
      <PracticeStructureSidebar
        entry={currentEntry ?? undefined}
        progress={progress}
        onSelect={selectEntry}
      />
    </>
  );
}
